module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/dialog/dialog.component.css
// module id = ./src/app/dialog/dialog.component.css
// module chunks = main